import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import axios from "axios";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";
import LinearProgress from "@material-ui/core/LinearProgress";
import config from "../../config";
import { Grid } from "@material-ui/core";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import AddIcon from "@material-ui/icons/Add";

const BACKEND_URL = config.backend.host;

const CustomTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
  imgSize: {
    width: "50px",
  },
  fab: {
    margin: theme.spacing(3),
    height: "10%",
    width: "3%",
    color: "white",
    backgroundColor: "#F6227F",
    "&:hover": {
      color: "white !important",
      backgroundColor: "#c41b63 !important",
    },
    borderRadius: 5,
  },
  button: {
    margin: 10,
  },
  extendedIcon: {
    marginRight: theme.spacing(),
  },
  select: {
    width: "200px",
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ededed",
    color: "black",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

class MediaList extends Component {
  _isMounted = false;

  state = {
    medias: [],
    name: [],
    brands: [],
    deleteId: "",
    openDeleteDialog: false,
    loading: true,
  };

  handleChange = (event) => {
    this.setState({ name: event.target.value });
  };

  handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
  };

  componentDidMount() {
    this._isMounted = true;
    //console.log("componentDidMount");
    this.listMedia();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  listMedia() {
    axios
      .get(BACKEND_URL + `/media/`)
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            medias: response.data,
            loading: false,
          });
          this.listBrand();
        }
      })
      .catch(function (error) {
        // console.log(error);
        //TODO: Show errors with snackbars
      });
  }

  getStyles(name, that) {
    return {
      fontWeight:
        that.state.name.indexOf(name) === -1
          ? that.props.theme.typography.fontWeightRegular
          : that.props.theme.typography.fontWeightMedium,
    };
  }

  listBrand() {
    axios
      .get(BACKEND_URL + "/brand/")
      .then((response) => this.setState({ brands: response.data }))
      .catch((err) => alert(err));
  }

  getBrandName(id) {
    //let brand = this.state.brands.filter(b => b._id === id)
    //return brand._id;
  }

  // btnDeleteOnClick(id, e){
  //   console.log('Deleted>> ID:' + id);
  //   axios.delete(`https://canadawho-backend-dev.herokuapp.com` + `/media/${id}`)
  //     .then(this.updateStateAfterDelete(id))
  //     .catch(function (error) {
  //       console.log(error);
  //       //TODO: Show errors with snackbars
  //     })
  // }

  updateStateAfterDelete(id) {
    // console.log('Deleted!');
    this.setState({
      medias: this.state.medias.filter((a) => a._id !== id),
    });
  }

  transition(props) {
    return <Slide direction="up" {...props} />;
  }

  btnDeleteOnClick(id, e) {
    this.setState({
      deleteId: id,
      openDeleteDialog: true,
    });
  }

  proceedDelete() {
    axios
      .delete(BACKEND_URL + `/media/${this.state.deleteId}`)
      .then(this.updateStateAfterDelete(this.state.deleteId))
      .catch(function (error) {
        alert(error);
        //TODO: Show errors with snackbars
      });
    this.setState({
      deleteId: "",
      openDeleteDialog: false,
    });
  }

  cancelDelete() {
    this.setState({
      deleteId: "",
      openDeleteDialog: false,
    });
  }

  render() {
    const { classes } = this.props;

    const addMediaLink = (props) => <Link to="/admin/media/add" {...props} />;

    return (
      <div>
        <Grid
          align="center"
          justify="space-evenly"
          container
          alignItems="center"
        >
          <Grid xs={8}>
            <Typography variant="h4">Media List</Typography>
          </Grid>
          <Tooltip title="Add Media">
            <Fab
              aria-label="Add"
              className={classes.fab}
              component={addMediaLink}
            >
              <AddIcon />
            </Fab>
          </Tooltip>
        </Grid>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <StyledTableCell>Image</StyledTableCell>
              <StyledTableCell>Title</StyledTableCell>
              <StyledTableCell></StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.medias.map((media) => (
              <TableRow className={classes.row} key={media._id}>
                <CustomTableCell align="left">
                  <img alt="" className={classes.imgSize} src={media.image} />
                </CustomTableCell>
                <CustomTableCell align="left">{media.title}</CustomTableCell>
                <CustomTableCell align="left">
                  <Tooltip title="Edit" aria-label="Edit">
                    <IconButton
                      aria-label="Edit"
                      className={classes.margin}
                      component={Link}
                      to={`/admin/media/edit/${media._id}`}
                    >
                      <EditIcon fontSize="small" style={{ color: "#F6277F" }} />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete" aria-label="Delete">
                    <IconButton
                      aria-label="Delete"
                      className={classes.margin}
                      onClick={this.btnDeleteOnClick.bind(this, media._id)}
                    >
                      <DeleteIcon
                        fontSize="small"
                        style={{ color: "#F6277F" }}
                      />
                    </IconButton>
                  </Tooltip>
                </CustomTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {this.state.loading ? <LinearProgress /> : ""}
        <Dialog
          open={this.state.openDeleteDialog}
          disableBackdropClick
          disableEscapeKeyDown
          aria-describedby="alert-dialog-description"
          TransitionComponent={this.transition}
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure that want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.cancelDelete.bind(this)}
              color="primary"
              autoFocus
            >
              No
            </Button>
            <Button onClick={this.proceedDelete.bind(this)} color="primary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MediaList);
